import Enumerable from "linq";
import {
  DocumentKind,
  IDocumentKindRepository,
} from "../../../domain/document";
import {
  AuthenticatedCachedRepository,
  AuthenticatedHttpClient,
} from "../..";

export class DocumentKindRepository extends AuthenticatedCachedRepository<string, DocumentKind> implements IDocumentKindRepository {
  constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken), DocumentKindRepository.createCache);
  }

  private static async createCache(client: AuthenticatedHttpClient): Promise<DocumentKind[]> {
    const url = "/api/format/reportTypes";
    const result = await client.get(url);
    const kinds = Enumerable.from(result.data)
      .cast<{ id: number, name: string }>()
      .select(x => new DocumentKind(x.id.toString(), x.name))
      .toArray();
    return kinds;
  }
}
